import React from 'react';

import { NavButton } from '@pkg/components/Navigation/SidebarNav/NavButton';
import { Buttons } from '@pkg/components/Navigation/SidebarNav/styles';
import { useAppSelector, useAuthentication } from '@pkg/hooks';

import config from '@app/config';
import { YAT_PROFILE_PAGE } from '@app/routes';
import { YAT_PICKER } from '@app/routes/paths';

import { YatFantasySection } from '../YatFantasySection';

import { Wrapper } from './styles';

const { privacyLink, supportLink, termsLink } = config;

export const LoggedOutSection = () => {
    const { yatFantasyEnabled } = useAppSelector((state) => state.featureFlags.features);
    const { authenticate } = useAuthentication();

    return (
        <Wrapper>
            <Buttons>
                <NavButton onClick={() => authenticate({ redirect: YAT_PROFILE_PAGE })}>
                    Sign up <span>or</span> Log in
                </NavButton>

                <NavButton to={YAT_PICKER}>Create Yats</NavButton>

                <NavButton to={supportLink} newTab>
                    Help Center
                </NavButton>

                <NavButton to={termsLink} newTab>
                    Terms of Service
                </NavButton>

                <NavButton to={privacyLink} newTab>
                    Privacy Policy
                </NavButton>
            </Buttons>

            {yatFantasyEnabled && <YatFantasySection isStatic={true} isOpen={true} />}
        </Wrapper>
    );
};
